module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "modal-image full-width",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c36918","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Image.vue
// module id = 1im0
// module chunks = 0 1